import { Component } from '@angular/core';
import { OrderMenuStore } from '../../../../stores/order-menu.store';
import { IOrderMenuItem } from '../../models/order-menu.models';
import { V2BottomSheetRef } from '../../../../v2-components/helpers/v2-bottom-sheet-ref';
import { LocationStore } from '../../../../stores/location.store';
import { RouterService } from 'services/router.service';
import { ItemDetailsStore } from 'stores/item-details.store';
import { BottomSheetService } from 'src/app/v2-components/services/bottom-sheet.service';
import { ReadonlyItemDetailsSheet } from '../readonly-item-details-sheet/readonly-item-details.sheet';
import { AsyncUtil } from 'utility/async.util';
import { RxUtil } from 'utility/rx.util';

@Component({
  selector: 'item-group-sheet',
  templateUrl: 'item-group.sheet.html',
  styleUrls: ['item-group.sheet.scss']
})
export class ItemGroupSheet {
  constructor(
    public orderMenuStore: OrderMenuStore,
    public locationStore: LocationStore,
    public itemDetailsStore: ItemDetailsStore,
    private bottomSheetRef: V2BottomSheetRef<V2BottomSheetRef>,
    private routerService: RouterService,
    private bottomSheetService: BottomSheetService
  ) {}

  async viewItemDetails(item: IOrderMenuItem): Promise<void> {
    const isMenuReadonly = await RxUtil.takeOne(
      this.locationStore.isMenuReadonly$
    );

    this.bottomSheetRef.close();
    if (isMenuReadonly) {
      await this.viewReadonlyItemDetails(item);
    } else {
      await this.routerService.viewItemDetailsPage(item);
    }
  }

  private async viewReadonlyItemDetails(item: IOrderMenuItem) {
    this.itemDetailsStore.selectedItemId = item.id;

    const readonlySheetRef = this.bottomSheetService.showBottomSheet(
      ReadonlyItemDetailsSheet
    );

    const proceededThroughBottomSheet = await RxUtil.takeOne(
      readonlySheetRef.onClose$
    );

    if (!proceededThroughBottomSheet) {
      this.bottomSheetService.showScrollableBottomSheetVariationHeader(
        ItemGroupSheet,
        item.name,
        item.description
      );
    }
  }
}
